import { t } from "@/plugins/i18n";

function districtIsNotANumber(election) {
  return isNaN(parseInt(election.district));
}

function isNotMassachusettsStateSenate(election) {
  return election.state_name !== "Massachusetts" && election.office !== "State Senate";
}

const nonLocalOfficeIDs = [
  1, // President
  2, // Governor
  3, // US House
  4, // US Senate
  8, // Lt. Governor
  9, // State House
  10, // State Senate
  27, // Attorney General
  28, // State Superintendent of Public Instruction
  30, // State Supreme Court
  39, // Secretary of State
  132, // Commonwealth Court
  133, // State Superior Court
  134, // Comptroller
  135, // Auditor
  136, // Agriculture Commissioner
  137, // Corporation Commissioner
  138, // Labor Commissioner
  139, // Superintendent of Public Instruction
  140, // Public Service Commissioner
  141, // Mine Inspector
  142, // Public Lands Commissioner
  143, // Controller
  144, // Insurance Commissioner
  145, // Tax Commissioner
  146, // Treasurer
  147, // Superintendent of Education
  148, // Public Utilities Commissioner
  149, // General Land Office Commissioner
  150, // Railroad Commissioner
  151, // State Board of Education
];

function isLocalElection(election) {
  return !nonLocalOfficeIDs.includes(election.office_id);
}

function getOfficeTranslation(office) {
  if (office === "State Senate") return t("message.stateSenate");
  if (office === "State House") return t("message.stateHouse");
  if (office === "US House") return t("message.usHouse");
  if (office === "US Senate") return t("message.usSenate");
  if (office === "Governor") return t("message.governor");
  if (office === "Secretary of State") return t("message.secretaryOfState");
  if (office === "Attorney General") return t("message.attorneyGeneral");
  if (office === "President") return t("message.president");

  return office;
}

function getPartyTranslation(party) {
  if (party === "Republican") return t("message.republican");
  if (party === "Democratic") return t("message.democratic");

  return party;
}

function getRaceNameTranslation(raceName) {
  if (raceName === "Primary") return t("message.primary");

  return raceName;
}

function getElectionState(election) {
  if (isLocalElection(election)) return "";

  return election.state_name + " ";
}

function getElectionOffice(election) {
  return getOfficeTranslation(election.office);
}

function getElectionDistrict(election) {
  if (!election.district) return "";

  if (election.district === "At-Large") {
    return " " + t("message.atLarge");
  }

  if (districtIsNotANumber(election) && isNotMassachusettsStateSenate(election)) {
    return " " + election.district;
  }

  return ` ${t("message.district")} ${election.district.replace(/^0+/, "")}`;
}

function getElectionParty(election) {
  if (!election.party || election.party === "Nonpartisan") return "";

  return " " + getPartyTranslation(election.party);
}

function getElectionRaceName(election) {
  if (election.name === "Ballot Question") return "";

  return " " + getRaceNameTranslation(election.name.replace(" Election", ""));
}

export function getFullElectionTitle(election) {
  return (
    getElectionState(election) +
    getElectionOffice(election) +
    getElectionDistrict(election) +
    getElectionParty(election) +
    getElectionRaceName(election)
  );
}

export function getShortElectionTitle(election) {
  if (!election.district) return getOfficeTranslation(election.office);
  if (districtIsNotANumber(election)) return election.district;

  if (election.district === "At-Large") {
    return `${t("message.district")} ${t("message.atLarge")}`;
  }

  return `${t("message.district")} ${election.district.replace(/^0+/, "")}`;
}

export function getTabTitle(election, hideState = false, hideOffice = false) {
  return (
    `${election.party ? election.party + " " : ""}${hideState ? "" : getElectionState(election)}` +
    `${hideOffice ? "" : getElectionOffice(election)}` +
    getElectionDistrict(election) +
    getElectionRaceName(election)
  );
}

export function getTabName(officeName) {
  return getOfficeTranslation(officeName);
}
